import { translatedOptions, visT } from "views/components/visualizations/visualizationTranslation";
import LineVisualization from "views/components/visualizations/line/LineVisualization";
import LineVisualizationConfig from "views/logic/aggregationbuilder/visualizations/LineVisualizationConfig";
import { hasAtLeastOneMetric } from "views/components/visualizations/validations";
import {
  DEFAULT_AXIS_CONFIG,
  DEFAULT_AXIS_TYPE,
  axisTypes
} from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import { DEFAULT_INTERPOLATION, interpolationTypes } from "views/Constants";
import xyAxisConfigFields, { fromAxisConfig } from "views/components/visualizations/xyAxisConfigFields";
const validate = hasAtLeastOneMetric("vis_validation.line_chart_requires_metric");
const lineChart = {
  type: LineVisualization.type,
  get displayName() {
    return visT("vis_types.line_chart");
  },
  component: LineVisualization,
  config: {
    createConfig: () => ({
      interpolation: DEFAULT_INTERPOLATION,
      axisType: DEFAULT_AXIS_TYPE,
      axisConfig: DEFAULT_AXIS_CONFIG
    }),
    fromConfig: (config) => {
      var _a, _b;
      return {
        interpolation: (_a = config == null ? void 0 : config.interpolation) != null ? _a : DEFAULT_INTERPOLATION,
        axisType: (_b = config == null ? void 0 : config.axisType) != null ? _b : DEFAULT_AXIS_TYPE,
        ...fromAxisConfig(config)
      };
    },
    toConfig: (formValues) => LineVisualizationConfig.create(
      formValues.interpolation,
      formValues.axisType,
      formValues.showAxisLabels ? formValues.axisConfig : DEFAULT_AXIS_CONFIG
    ),
    fields: [
      {
        name: "interpolation",
        get title() {
          return visT("vis_common.interpolation");
        },
        type: "select",
        get options() {
          return translatedOptions(interpolationTypes, "vis_common.interpolation_types");
        },
        required: true
      },
      {
        name: "axisType",
        get title() {
          return visT("vis_common.axis_type");
        },
        type: "select",
        get options() {
          return translatedOptions(axisTypes, "vis_common.axis_types");
        },
        required: true
      },
      ...xyAxisConfigFields
    ]
  },
  capabilities: ["event-annotations"],
  validate
};
export default lineChart;
